/*
 * @Author: Chenhw2017 1272617071@qq.com
 * @Date: 2024-07-20 17:59:29
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-08-02 14:23:06
 * @FilePath: /seller.sviptrader.com/src/utils/hotFresh/cache.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export const getCache = () => {
	const cache = sessionStorage.getItem('rdyHotFresh');
	if (!cache) {
		return null;
	} else {
		const { expired, rules } = JSON.parse(cache);
		if (Date.now() > +expired) {
			sessionStorage.removeItem('rdyHotFresh');
			return null;
		} else {
			return rules || [];
		}
	}
};

// 默认缓存15分钟
export const setCache = (rules, cache_time = 900) => {
	if (!cache_time || !rules) {
		return;
	}
	const cache = {
		// 过期时间
		expired: Date.now() + cache_time * 1000,
		rules: rules,
	};
	sessionStorage.setItem('rdyHotFresh', JSON.stringify(cache));
	return rules;
};

// 清楚缓存
export const clearCache = () => {
	sessionStorage.removeItem('rdyHotFresh');
	sessionStorage.removeItem('CURRENT_PAGE_VERSION');
};
